import limitPrecision from 'editor/src/util/limitPrecision';

import { AreaClip } from 'editor/src/component/EditorArea/Spread/Page/MediaElement/Image/types';

import { RectMediaElement } from './utils';

/**
 * Maps an element's frame onto the destination page one axis at a time, so the margins it had
 * around it stay proportional instead of growing when the page changes shape.
 *
 * Only the frame is stretched. `updateImageElement` afterwards re-crops the bitmap to cover that
 * frame, so the picture itself never distorts — it shows slightly more or less of itself instead.
 * Text passes `uniformScale` so glyphs keep their proportions while the block still travels with
 * the page.
 */
function applyFillToRectangleElement(
  sourceElement: RectMediaElement,
  sourceMediaBox: AreaClip,
  destElement: RectMediaElement,
  destMediaBox: AreaClip,
  uniformScale?: number,
) {
  const scaleX = destMediaBox.width / sourceMediaBox.width;
  const scaleY = destMediaBox.height / sourceMediaBox.height;

  destElement.width = limitPrecision(sourceElement.width * (uniformScale ?? scaleX));
  destElement.height = limitPrecision(sourceElement.height * (uniformScale ?? scaleY));
  destElement.x = limitPrecision(destMediaBox.x + (sourceElement.x - sourceMediaBox.x) * scaleX);
  destElement.y = limitPrecision(destMediaBox.y + (sourceElement.y - sourceMediaBox.y) * scaleY);
}

export default applyFillToRectangleElement;
